module.exports = __webpack_public_path__ + "img/jtb-avatar-7583.6f190473.jpg";